import SkeletonShippinGroupDetail from "@Components/Commons/Skeleton/SkeletonShippinGroupDetail"
import SummaryProductList from "@Components/OrderDetail/SummaryProducts/SummaryProductsList"
import TagPrintContent from "@Components/OrderDetail/TagPrint/TagPrintContent"
import { AuthContext } from "@Context/context/AuthContext"
import OrderDetailHOC from "@Hoc/OrderDetailHOC"
import { OrderDetailType } from "@Types/OrderType"
import { clients } from "@Webapp-Clients/Clients"
import { Suspense, useContext } from "react"
import useDeliveredOrder from "@Pages/DetailOrderScreens/Delivered/UseDeliveredOrder"
import { COUNT_MAX_FILE } from "@Helpers/constHelper"
import { useForm } from "react-hook-form"
import { FilesFormType } from "@Types/FilesFormType"
import { yupResolver } from "@hookform/resolvers/yup"
import { shemaFileUpladerForm } from "@Config/ShemaForms"
import AlertStyled from "@Theme/common/Alert.styled"
import { IconAttachment } from "@Theme/common/Icon.styled"
import { ErrorFieldForm } from "@Theme/common/Paragraph.styled"
import { ButtonStyled } from "@Theme/common/Button.styled"
import { IconCheck } from "@Theme/common/Icon.styled"
import ContentDetailOrderActionsStyled from "@Theme/common/ContentDetailOrderActions.styled"

const DeliveredScreen = ({ shippinGroupDetail, shippingGroupId, order }: OrderDetailType) => {
  const {
    state: { user },
  } = useContext(AuthContext)

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const FilesList = client["FilesList" as keyof typeof client]
  const ContentFileMedia = client["ContentFileMedia" as keyof typeof client]
  const FileUpload = client["FileUpload" as keyof typeof client]

  const itemsOrder = shippinGroupDetail?.source.items
  const documents = shippinGroupDetail?.custom?.documents
  const elockerInfo = shippinGroupDetail?.custom?.infoElocker

  const files = shippinGroupDetail?.status
    .filter(({ media }) => media)
    .flatMap(({ media }) => media?.ref.map(({ id }) => id))

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FilesFormType>({
    resolver: !!FileUpload ? yupResolver(shemaFileUpladerForm(files || [])) : undefined,
  })

  const { submitFilesDeliveredOrder, loadingDelivered, hasPermissionUploadFiles } = useDeliveredOrder({
    shippingGroupId,
    order
  })

  return (
    <>
      {itemsOrder ? (
        <>
          <SummaryProductList
            itemsOrder={itemsOrder}
            groupPicking={false}
            titleMain={"Productos entregados"}
          />
          {(files || []).length < 3 && hasPermissionUploadFiles && (
            <>
              <form onSubmit={handleSubmit(submitFilesDeliveredOrder)}>
                {FileUpload && (
                  <Suspense fallback={null}>
                    <section className="padding-content ">
                      <AlertStyled variant="info" className="m-top-button1">
                        <IconAttachment />
                        <p>Adjuntar máximo {COUNT_MAX_FILE - (files || []).length} archivo(s)</p>
                      </AlertStyled>
                      <FileUpload
                        register={register}
                        setValue={setValue}
                      />
                    </section>
                  </Suspense>
                )}

                {errors.filesShippinGroup && (
                  <ErrorFieldForm>{errors.filesShippinGroup.message}</ErrorFieldForm>
                )}
                <ContentDetailOrderActionsStyled>
                  <ButtonStyled variant="primary" loadingButton={loadingDelivered} disabled={loadingDelivered}>
                    <IconCheck />
                    <span>Guardar archivo</span>
                  </ButtonStyled>
                </ContentDetailOrderActionsStyled>
              </form>
            </>
          )}
          {order && (
            <TagPrintContent
              codigoEntrega={(elockerInfo?.isElocker && elockerInfo?.codigoEntrega) || null}
              order={order}
              shippingGroupId={shippingGroupId}
            />
          )}

          {ContentFileMedia && files && files.length > 0 && (
            <Suspense fallback={null}>
              <ContentFileMedia listIdFiles={files} shippingGroupId={shippingGroupId} />
            </Suspense>
          )}
          {FilesList && (
            <Suspense fallback={null}>
              <FilesList
                documents={documents}
                channel={shippinGroupDetail?.channel}
                orderId={order?.id}
              />
            </Suspense>
          )}
        </>
      ) : (
        <SkeletonShippinGroupDetail />
      )}
    </>
  )
}

export default OrderDetailHOC(DeliveredScreen)
